import React from 'react';
import './StepperComponent.scss';

/**
 * Reusable stepper component for multi-step processes.
 *
 * @param {Object} props
 * @param {Array<{key: string, label: string}>} props.steps - Array of steps { key, label }
 * @param {string} props.activeStepKey - Key of the currently active step
 * @param {string|number} [props.maxWidth='440px'] - Max width of the stepper container
 * @param {string} [props.className] - Additional CSS class for the container
 */
const StepperComponent = ({steps, activeStepKey, maxWidth = '440px', className = ''}) => {
  if (!steps || steps.length === 0) return null;

  const getStepStatus = (stepIndex) => {
    const activeIndex = steps.findIndex((s) => s.key === activeStepKey);
    if (activeIndex === -1) return 'pending';
    if (stepIndex < activeIndex) return 'completed';
    if (stepIndex === activeIndex) return 'active';
    return 'pending';
  };

  const containerStyle = {
    maxWidth: typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth,
  };

  return (
    <div className={`stepper-component ${className}`.trim()} style={containerStyle}>
      <div className='stepper-component__track'>
        {steps.map((step, index) => {
          const status = getStepStatus(index);
          const isLast = index === steps.length - 1;

          return (
            <React.Fragment key={step.key}>
              <div className={`stepper-component__step stepper-component__step--${status}`} data-status={status}>
                <span className='stepper-component__circle' />
                <span className='stepper-component__label'>{step.label}</span>
              </div>
              {!isLast && <div className='stepper-component__connector' />}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default StepperComponent;
